export const languages = {
   en: "Inglés",
   es: "Español"
}